<template>
  <pageContent class="contacto">
    <div class="contacto-main">
      <div class="row-text fade-in">
        
        <h1 class="font-blod" style="white-space: nowrap;"> Cuéntanos tu proyecto, tu idea, tu sueño</h1>
        <h1 class="font-blod black">y te ayudaremos a llevarlo a cabo</h1>
      </div>
      <div class="text-center fade-in">
        <i
          >Nuestra finalidad es dar respuesta profesional a todos los procesos
          intervinientes en la construcción.</i
        >
      </div>
      <div class="row">
        <div>
          <div class="icon-text">
            <img class="icon" src="../../assets/img/icon7.svg" />
            <span class="name1 fade-in">Llámanos</span>
            <el-link class="fade-in" href="tel:603440332">603 440 332</el-link>
          </div>
          <div class="icon-text">
            <img class="icon" src="../../assets/img/icon8.svg" />
            <span class="name1 fade-in">Escríbenos</span>
            <el-link class="fade-in" href="mailto:info@maragonconstruccion.es">
              info@maragonconstruccion.es
            </el-link>
          </div>
        </div>
      </div>

      <el-form class="form" :model="form" :rules="rules">
        <div class="left">
          <el-form-item prop="nombre" label="Nombre">
            <el-input v-model="form.nombre"></el-input>
          </el-form-item>
          <el-form-item prop="apelli" label="Apellido">
            <el-input v-model="form.apelli"></el-input>
          </el-form-item>
          <el-form-item prop="email" label="Email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
          <el-form-item prop="tel" label="Teléfono">
            <el-input v-model="form.tel"></el-input>
          </el-form-item>
          <el-form-item prop="mensaje" label="Mensaje">
            <el-input type="textarea" v-model="form.mensaje"></el-input>
          </el-form-item>
        </div>
        <div class="right">
          <el-checkbox v-model="form.checked"></el-checkbox>
          <h1 class="form-text">Acepto la política de privacidad</h1>
          <p>
            MARAGON te informa de que los datos de carácter per sonal que nos
            proporciones rellenando este formulario serán tratados por nosotros
            (MARAGON EFICIENCIA EN CONSTRUCCIÓN S.L.) como responsables de esta
            web. La finalidad de la recogida y tratamiento de los datos
            personales que te solicitamos es para gestionar la solicitud que
            realizas en este formulario de contacto y poder disponer de tu
            contacto para poder mantener conversaciones contigo.
          </p>
          <p>
            Legitimación: Consentimiento del interesado. Como usuario e
            interesado te informo que los datos que me facilitas estarán
            ubicados en los servidores de Hostalia (mi proveedor de hosting y de
            email) dentro de la UE. Ver política de privacidad de Hostalia. El
            no introducir los datos de carácter personal que aparecen en el
            formulario como obligatorios tendrá como consecuencia que no pueda
            atender tu solicitud.
          </p>
          <p>
            Podrás ejercer tus derechos de acceso, rectificación, limitación y
            suprimir los datos en info@maragonconstruccion.es así como el
            derecho a presentar una re lamación ante una autoridad de control.
            Si lo deseas, puedes consultar la información adicional y detallada
            sobre la política de privacidad y el aviso legal en nuestra página
            web maragonconstruccion.es.
          </p>
          <div class="btn">
            <el-link :underline="false">Enviar</el-link>
          </div>
        </div>
      </el-form>
    </div>
  </pageContent>
</template>

<script>
import pageContent from "@/components/pageContent.vue"
export default {
  name: "contacto",
  components: {
    pageContent,
  },
  data() {
    return {
      rules: {
        nombre: [{ required: true, message: "Campo Obligatorio", trigger: "blur" }],
        email: [{ required: true, message: "Campo Obligatorio", trigger: "blur" }],
      },
      form: {},
    }
  },
  methods: {
    openPage(idx) {
      this.$router.push({ path: `/obras?row=${idx}` })
    },
  },
}
</script>
<style lang="scss" scoped>
.contacto-main {
  position: relative;
  top: -112px;
  .row-text {
    text-align: center;
    color: #fff;
    opacity: 0;
    animation-delay: 1s;
    .font-blod {
      font-size: calc(var(--font-size) * 2);
      &.black {
        color: #000000;
      }
    }
  }
  .text-center {
    margin-top: 80px;
    font-size: 50px;
    opacity: 0;
    animation-delay: 1.2s;
  }
  .row {
    display: flex;
    justify-content: center;
    padding-top: 90px;
    padding-bottom: 50px;
    .icon-text {
      display: flex;
      align-items: center;
      margin-bottom: 50px;
      .icon {
        width: 117px;
        height: 117px;
        margin-right: 80px;
      }
      .name1 {
        display: inline-block;
        width: 170px;
        margin-right: 40px;
        opacity: 0;
        animation-delay: 1s;
      }
      .el-link {
        font-family: font_blod;
        font-size: var(--font-size);
        color: #000;
        font-weight: bolder;
        opacity: 0;
        animation-delay: 1s;
      }
    }
  }
}
</style>
